export default __webpack_public_path__ + "static/media/74.36f2ab99.jpg";